import axios from 'axios';
import getCookie from 'js-cookie';
import apiBaseUrl from '@/plugins/api/apiBaseUrl';
import Log from '@/plugins/api/Log';

export default class RdStation {
  public static async conversion(data: {}) {
    const emptyPhoneFields = Object.entries(data)
      .filter(([k, v]) => ['telefone', 'celular'].includes(k) && !v)
      .map(([k]) => k);
    if (emptyPhoneFields.length > 0) {
      const message = `RdStation.conversion: campo(s) ${emptyPhoneFields.join(', ')} vazio(s), não serão enviados`;
      // eslint-disable-next-line no-console
      console.warn(message, data);
      Log.warn('rdstation', { message, data }).then();
    }

    // Remove todos os ( "", 0, false, null, undefined )
    data = Object.entries(data).reduce((a: any, [k, v]) => {
      return (v ? (a[k] = v, a) : a);
    }, {});

    const response = await RdStation.instance
      .post('/rdstation.php', { ...RdStation.getData(), ...data, origem: window.location.href });
    return response.data;
  }

  private static instance = axios.create({
    baseURL: apiBaseUrl,
  });

  private static firstConversion = true;

  private static getData() {
    let data: any = {};
    if (RdStation.firstConversion) {
      RdStation.firstConversion = false;
      data = {
        ...data,
        traffic_source: getCookie.get('__trf.src'),
        c_utmz: getCookie.get('__utmz'),
        client_id: getCookie.get('rdtrk'),
      };
    }
    return data;
  }
}
